<div id="main-content">
  <div class="container-fluid">
    <app-breadcrumb [dataInput]="breadCrumb"></app-breadcrumb>

    <div class="row clearfix">

      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card overflowhidden number-chart">
          <div class="body">
            <div class="number">
              <h6>Number of Agents</h6>
              <span>{{ summary?.agent_count || 0 }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card overflowhidden number-chart">
          <div class="body">
            <div class="number">
              <h6>Number of Inactive Agents</h6>
              <span>{{ inactive || 0 }}</span>
            </div>
          </div>
        </div>
      </div>
     <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card overflowhidden number-chart">
          <div class="body">
            <div class="number">
              <h6>Ticket Count </h6>
              <span>{{ summary?.ticket_count || 0 }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card overflowhidden number-chart">
          <div class="body">
            <div class="number">
              <h6>Near Limit</h6>
              <span>{{ summary?.near_limit_count || 0 }}</span>
            </div>
          </div>

        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card overflowhidden number-chart">
          <div class="body">
            <div class="number">
              <h6>Total Amount</h6>
              <span>&#8358;{{ summary?.total_amount || 0 }}</span>
            </div>
          </div>

        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card overflowhidden number-chart">
          <div class="body">
            <div class="number">
              <h6>Offline Agents </h6>
              <span>{{ summary?.sync_stale_count || 0 }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row clearfix">
    </div>
  </div>
</div>
